module.exports = __webpack_public_path__ + "img/first-day-4.d6a756a8.webp";